import {
  BadgeProps, ICON_ARROW_DOWN, ICON_ARROW_UP, ICON_CHECK_CIRCLE_OUTLINE, ICON_MINUS,
  ICON_PROGRESS_CHECK,
  SelectOption,
} from '@doveit/bricks';
import { TaskPriority, TaskStatus } from '../domain/types';
import { UserRole } from '../types';
import { removeNullAndUndefinedValues } from '../utils/array';

export const taskStatusColors: Record<TaskStatus, BadgeProps['color']> = {
  [TaskStatus.TODO]: 'warning',
  [TaskStatus.IN_PROGRESS]: 'info',
  [TaskStatus.DONE]: 'success',
};

export const taskPriorityColors: Record<TaskPriority, BadgeProps['color']> = {
  [TaskPriority.HIGH]: 'critical',
  [TaskPriority.MEDIUM]: 'warning',
  [TaskPriority.LOW]: 'neutral',
};

export const taskPriorityIcons: Record<TaskPriority, string> = {
  [TaskPriority.HIGH]: ICON_ARROW_UP,
  [TaskPriority.MEDIUM]: ICON_MINUS,
  [TaskPriority.LOW]: ICON_ARROW_DOWN,
};

export const taskStatusIcons: Record<TaskStatus, string> = {
  [TaskStatus.TODO]: ICON_PROGRESS_CHECK,
  [TaskStatus.IN_PROGRESS]: ICON_PROGRESS_CHECK,
  [TaskStatus.DONE]: ICON_CHECK_CIRCLE_OUTLINE,
};

/**
 * TODO: remove after https://doveit.atlassian.net/browse/DOVE-14128
 */
export const contentEditorUsers = [
  {
    name: 'Cinzia Balbo',
    email: 'cinzia.balbo@dove.it',
  }, {
    name: 'Chiara Vigorelli',
    email: 'chiara.vigorelli@dove.it',
  }, {
    name: 'Andrea Petteni',
    email: 'andrea.petteni@dove.it',
  }, {
    name: 'Daniela Palmisano',
    email: 'daniela.palmisano@dove.it',
  }, {
    name: 'Giulia Razzini',
    email: 'giulia.razzini@dove.it',
  }, {
    name: 'Viviana Saibene',
    email: 'viviana.saibene@dove.it',
  }, {
    name: 'Emanuele Zampieri',
    email: 'emanuele.zampieri@dove.it',
  },
];

/**
 * @todo replace with actual users retrieved from auth0
 */
export const getAssigneeOptions = (currentUserRole: UserRole): SelectOption[] => removeNullAndUndefinedValues([
  {
    label: 'Non assegnato',
    value: '',
  },
  ...contentEditorUsers.map((user) => ({
    label: user.name,
    value: user.email,
  })),
  currentUserRole === UserRole.DEVELOPER ? {
    label: 'Test Content',
    value: 'test.content@dove.it',
  } : undefined,
]);
